<template>
  <div class="home">
    <v-content>
      <!-- <section > -->
    <sequential-entrance fromTop delay="3000">
      <v-parallax class="bg-img" height="1050">
        <v-layout column align-center>
          <div class="logo-pos">
            <img src="@/assets/logo_home@2x.png" height="120" />
          </div>

          <!-- Available Area -->
          <div class="available_area">
            <h6 class="font-weight-medium">Available on:</h6>
            <ul>
              <li>
                <img src="@/assets/icon_apple.png" alt />
              </li>
              <li>
                <img src="@/assets/icon_android.png" alt />
              </li>
              <li>
                <img src="@/assets/icon_windows.png" alt />
              </li>
            </ul>
            <h6 class="font-weight-medium">Desktop & Mobile</h6>
          </div>
          <div class="slogan">
            <h3
              class="font-weight-light"
            >Cogneetiv is an AI Voice Assistant with a visual interface for BI.</h3>
          </div>
          <div>
            <v-btn column color="green-btn" v-on:click="nav('login')" dark large>Schedule a Demo</v-btn>
          </div>
        </v-layout>
      </v-parallax>
    </sequential-entrance>

      <section>

        <v-layout class="" column wrap align-center>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex
                      class="margin"
                      xs12
                      md6
                      lg12>
        <sequential-entrance fromBottom delay="20000">
                      <v-layout row wrap class="my-12">
                        <v-flex xs12 sm12 md12>
                          <div class="intro">

                            <h3 class="display-1">Join the AI Voice Assistant Revolution.</h3>

                          </div>
                          <br />
                          <br />
                          <br />
                          <br />

                          <div>
                            <div class="mic-animate">
                              <img src="@/assets/DarkTechMicSvg_4_5animated.svg" class="mic" />
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
       </sequential-entrance>
                      <br />
                      <br />

                      <h4
                        class="display-2"
                      >Cogneetiv leverages artificial intelligence & machine learning to track and optimize your business efficiency, all in real time.</h4>
                      <br />
                      <p
                        class="display-1 font-weight-light"
                      >Complete tasks, and execute workflows all while reaching company milestones sooner. Start your day with your daily briefing, and then stay on track with your business AI voice assistant, who will then help execute your day to day responsibilities with a simple voice command.</p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>

      <v-parallax class="bg-img2" height="800">
        <v-layout column wrap align-left>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-left>
                <v-flex
                      class="margin"
                      xs12
                      md6
                      lg5>

                      <br />

                      <p
                        class="display-2 font-weight-light"
                      >You have grown to love Alexa, Siri, and Google like AI Assistants, because they simplify your life. Cogneetiv brings the power of artificial intelligence & machine learning into the worlds first AI Assistant for Business, all to help you run your business efficiently.</p>
                      <br />

                </v-flex>
              </v-layout>


            </v-container>
          </v-flex>
        </v-layout>
      </v-parallax>

        <v-layout class="my-16" column wrap align-center>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex
                      class="margin"
                      xs12
                      md6
                      lg12>
        <sequential-entrance fromBottom delay="20000">
                      <div class="feature_image">
                        <img src="@/assets/mockups/UICards.png" alt class="img_responsive" />
                      </div>
        </sequential-entrance>
                      <br />
                      <p
                        class="display-1 font-weight-light"
                      >Cogneetiv creates, manages and tracks executable task & milestone paths, that help meet company goals ahead of schedule. Users start their day with a daily briefing, and then use any of the already over 25 voice action that work on the UI card. Use your voice to have Cogneetiv execute action based commands to execute tasks and stay on track. Cogneetiv is an a AI voice assistant unlike any other, so go ahead Mr. Stark and meet your new assistant. Cogneetiv can send emails, search, pull up reports, show & check your calendar, or maybe update your tasks, or even pull up your agenda. You can also create voice forms, send and check emails, check contextual data and so much more.</p>

                </v-flex>
              </v-layout>


            </v-container>
          </v-flex>
        </v-layout>




        <v-layout class="bg-img3" column wrap align-center>
          <v-flex xs12>
            <v-container grid-list-xl>



              <v-divider></v-divider>
              <v-layout row wrap align-center>
                <v-flex xs12 md6>

                    <v-card-text class="text-align">

                    <div class="slogan">
                    <h3 class="display-2">Machine Learning</h3>
                    <br />
                      <h5
                        class="font-weight-light"
                      >Cogneetiv leverages the power of Machine Learning to help you grade the health of your business.</h5>
                    </div>
                    </v-card-text>





                </v-flex>
                <v-flex xs12 md6>
                  <div class="feature_image">
                    <img src="@/assets/mockups/1.png" alt class="img_responsive" />
                  </div>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>

                    <v-card-text class="text-align">
                      <div class="display-2">
                        <h5>CENTRALIZED DATA</h5>

                      </div>

                      <br />
                      <br />
                      <br />
                      <div class="display-2">
                        <h5>VOICE RESPONSIVE</h5>

                      </div>
                    </v-card-text>

                </v-flex>
                <v-flex xs12 md4>
                  <div class="feature_image" align-center>
                    <img src="@/assets/mockups/3.png" alt class="img_responsive" />
                  </div>
                </v-flex>
                <v-flex xs12 md4>

                    <v-card-text class="text-align">
                      <div class="display-2">
                        <h5>BUSINESS ALERTS</h5>

                      </div>
                      <br />
                      <br />
                      <br />
                      <div class="display-2">
                        <h5>SMART ASSISTANT</h5>

                      </div>
                    </v-card-text>

                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout row wrap class="my-12">
                <v-flex xs12 sm12 md12>
                  <v-card-text class="text-align">
                    <div class="intro">
                      <h2 class="display-2">Dashboard Screenshots</h2>
                      <h5
                        class="headline font-weight-light"
                      >Take a quick look at our Cogneetiv AI business dashboard layout.</h5>
                    </div>
                  </v-card-text>
                </v-flex>
                <br />
                <v-flex xs12 sm6 md3>
                  <v-card class="my-13" flat>
                    <img
                      src="@/assets/screenshots/1.jpg"
                      class="img_responsive img-rounded_corner"
                      alt
                      width="528"
                    />
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-card class="my-13" flat>
                    <img
                      src="@/assets/screenshots/2.jpg"
                      class="img_responsive img-rounded_corner"
                      alt
                      width="528"
                    />
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-card class="my-13" flat>
                    <img
                      src="@/assets/screenshots/3.jpg"
                      class="img_responsive img-rounded_corner"
                      alt
                      width="528"
                    />
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-card class="my-13" flat>
                    <img
                      src="@/assets/screenshots/4.jpg"
                      class="img_responsive img-rounded_corner"
                      alt
                      width="528"
                    />
                  </v-card>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>

              <v-layout row align-center wrap class="my-12">
                <v-flex xs12 sm12 md12>
                  <div class="intro">
                    <h2 class="display-2">Cogneetiv Team</h2>
                    <br />
                    <h5
                      class="headline font-weight-light"
                    >The hard working team that is developing Cogneetiv.</h5>
                  </div>
                </v-flex>
                <template v-for="(member, index) in team">
                  <v-flex :key="index" xs12 md4>

                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title>
                            <img src="@/assets/john.jpg" height="250px" v-if="index==0" />
                            <img src="@/assets/atul.jpg" height="250px" v-if="index==1" />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="display-2 font-weight-thin">{{member.name}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="width-mx"></v-divider>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline">{{member.role}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <br />

                  </v-flex>
                </template>
              </v-layout>
              <v-divider></v-divider>

              <v-layout row wrap class="my-12">
                <v-flex xs12 sm12 md8>

                    <v-card-text class="text-align">
                      <div class="bring-center">
                        <h2 class="display-1">Contact Us</h2>
                        <br />
                        <h3
                          class="title font-weight-light"
                        >Contact Cogneetiv using contact form below.</h3>
                      </div>

                      <v-form ref="form" v-model="valid" lazy-validation style="width:90%">
                        <v-text-field
                          v-model="name"
                          :counter="10"
                          :rules="nameRules"
                          label="Your Name"
                          required
                        ></v-text-field>

                        <v-text-field
                          v-model="email"
                          :rules="emailRules"
                          label="Your E-mail"
                          required
                        ></v-text-field>

                        <v-text-field label="Message"></v-text-field>

                        <v-checkbox
                          v-model="checkbox"
                          :rules="[v => !!v || 'You must agree to continue!']"
                          label="Do you agree?"
                          required
                        ></v-checkbox>

                        <v-btn
                          :disabled="!valid"
                          color="green-btn"
                          class="mr-4"
                          @click="validate"
                        >Submit</v-btn>
                      </v-form>
                    </v-card-text>

                </v-flex>
                <v-flex xs12 sm12 md4>

                    <v-card-text >
                      <h3 class="display-1">Contact Info</h3>
                      <br />
                      <h3
                        class="title font-weight-light"
                      >Please fill out the form and one of our Cogneetiv agents will be in touch.</h3>


                    </v-card-text>
                    <br />


                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon>home</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              14429 Ventura Blvd. Ste. # 109
                              <br />Sherman Oaks, CA 91423
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon>phone</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>(818)602-9470</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon>email</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>info@cogneetiv.com</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>


                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>

        <br />
        <br />

      </section>
    </v-content>

    <footer>
      <v-flex xs12 sm12 md12>
        <div class="intro">
          <div class="social_icons">
            <ul>
              <li>
                <i class="fa fa-twitter" style="font-size:30px"></i>
              </li>
              <li>
                <i class="fa fa-facebook-official" style="font-size:30px"></i>
              </li>
              <li>
                <i class="fa fa-linkedin" style="font-size:30px"></i>
              </li>
            </ul>
          </div>
          <br />
          <h2 class="title">Copyright © 2020 COGNEETIV</h2>
        </div>
      </v-flex>
    </footer>
  </div>
</template>

<style scoped>
.db-content {
	background: linear-gradient(-45deg, #78b59c, #252b45, #364068, #31577c, #1b255b, #1c324a);
	background-size: 400% 400%;
  min-height: 100vh;
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.bg-img {
  background-image: url("./../assets/assets/CogBG2.jpg");
  background-position: 50% 99.9%;
  background-size: cover;
  border: none !important;
}
.footer {
  background: #ccc;
}
.bg-img2 {
  background-image: url("./../assets/assets/CogneetivData.jpg");
  background-position: 50% 99.9%;
  background-size: cover;
  border: none !important;
}

.bg-img3 {
  background-image: url("./../assets/assets/home_bg_LINES_COG2.jpg");
  background-position: 50% 99.9%;
  background-size: cover;
  border: none !important;
}
.margin {
 margin: 175px;
}

.logo-pos {
  margin-top: 50px;
  margin-bottom: 40px;
}
.available_area {
  margin: 10px 0px;
}
.available_area ul {
  display: inline-block;
  opacity: 0.5;
  list-style: none;
}
.available_area ul li img {
  width: 1rem;
  margin: 0;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}
.available_area ul li {
  float: left;
  line-height: 0;
}
.available_area h6 {
  display: inline;
  color: #8b8aa0;
}
.available_area ul {
  margin: 0 0.2rem;
  padding: 0px !important;
}
h6 {
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  font-size: 0.92rem;
  line-height: 1rem;
  margin: 0px 0px 0rem 0px;
}
.green-btn {
  background: #78b59c !important;
}
.slogan {
  font-weight: 200;
  letter-spacing: 0.01rem;
  font-size: 2.21rem;
  line-height: 3.64rem;
  margin: 3.72rem 0px 4.72rem 0px;
  max-width: 700px;
  text-align: center;
}
.text-align {
  text-align: center;
  color: #fff;
}
.feature_image {
  margin-top: 5rem;
  padding-bottom: 3rem;
}
.feature_image .bring-center {
  text-align: center;
}
.feature_content {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
}
i {
  color: #000;
}
.intro {
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
}

.display-1 {
  color: rgba(0, 0, 0);
  text-align: center;
}

.display-2 {
  color: rgba(66, 218, 145);
  text-align: center;
}

.display-3 {
  color: rgba(0, 0, 0);
  text-align: center;
}

.display-4 {
  color: rgba(0, 0, 0);
  text-align: center;
}


.my-15 {
  background: #023145;
  //background-image: url("./../assets/home_bg_03_COG.jpg");
}

.my-16 {
  background: #46dc95;
}

.img_responsive {
  max-width: 100%;
}
.width-mx {
  max-width: 70% !important;
}
.icon-fnt {
  font-size: 50px;
}
.social_icons ul,
.social_icons ul li {
  display: inline-block;
  list-style: none;
  padding: 0px 19px;
  height: 2rem;
}
footer {
  background: #42da91;
  color: #fff;
  padding: 15px 0px 10px 0px;
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.mic-animate {
  margin: -50px auto;
  width: 100px;
  height: 100px;
  font: 13px/130px "Barlow Semi Condensed", sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #fff;
  text-align: center;
  background: rgb(66, 218, 145);
  border-radius: 50%;
  animation: shadow-pulse 1s infinite;
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .available_area {
    max-width: 235px;
    text-align: center;
  }
}
</style>

<script>
// @ is an alias to /src

export default {
  name: "home",
  methods: {
    nav(path) {
      this.$router.push({ name: path });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    }
  },
  data() {
    return {
      valid: true,
      name: "",
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      email: "",
      checkbox: false,
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      select: null,
      team: [
        {
          name: "John Salinas",
          role: "CEO",
          img: "./assets/john.jpg"
        },
        {
          name: "Atul Verma",
          role: "CTO",
          img: "./assets/atul.jpg"
        }
      ],
      pricing: [
        {
          title: "Single",
          price: "$49",
          icon: "person",
          users: "1 User",
          projects: "10 Project",
          emailAccount: "5 Email Accounts"
        },
        {
          title: "Multiple",
          price: "$59",
          icon: "supervisor_account",
          users: "3 Users",
          projects: "30 Projects",
          emailAccount: "10 Email Accounts"
        },
        {
          title: "Agency",
          price: "$199",
          icon: "business",
          users: "Unlimited Users",
          projects: "Unlimited Projects",
          emailAccount: "Unlimited Email Accounts"
        }
      ]
    };
  }
};
</script>
